module.exports = __webpack_public_path__ + "static/media/education-deepa.e446685e.png";